import { useState, useEffect } from "react";
import type { POI } from "../../components/MapCanvas";
import type { UserLocation } from "../useUserLocation";
import type { POIDestination } from "../useWayfinding";

interface ArrivalModalOptions {
  location: UserLocation | null;
  isNavigating: boolean;
  destination: POIDestination | null;
  pois: POI[];
  checkArrival: (location: UserLocation) => boolean;
  cancelNavigation: () => void;
}

export function useArrivalModal({
  location,
  isNavigating,
  destination,
  pois,
  checkArrival,
  cancelNavigation,
}: ArrivalModalOptions) {
  const [showArrivalModal, setShowArrivalModal] = useState(false);
  const [arrivedPOI, setArrivedPOI] = useState<POI | null>(null);

  // Check arrival on location update
  useEffect(() => {
    if (!location || !isNavigating) return;
    if (checkArrival(location)) {
      const poi = pois.find((p) => p.id === destination?.id);
      if (poi) {
        setArrivedPOI(poi);
        setShowArrivalModal(true);
        cancelNavigation();
      }
    }
  }, [location, isNavigating, checkArrival, destination, pois, cancelNavigation]);

  const handleArrivalClose = () => {
    setShowArrivalModal(false);
    setArrivedPOI(null);
  };

  return {
    showArrivalModal,
    arrivedPOI,
    handleArrivalClose,
  };
}
